export default __webpack_public_path__ + "static/media/87.7029cba7.gif";